import React from 'react';
import { IEventConditionFieldsFragment } from '../../../utils/apollo/graphqlSchema';
import SpecialEventLabel from './SpecialEventLabel';
import EventConditionInfo from './EventConditionInfo';

interface IProps {
  eventCondition: IEventConditionFieldsFragment;
  index: number;
}

export default ({ eventCondition, index }: IProps) => {
  return (
    <EventConditionInfo
      label={
        <SpecialEventLabel
          iconName="fold-event-active"
          iconPositiveIndex={index + 1}
        >
          Fold Event(s)
        </SpecialEventLabel>
      }
      condition={eventCondition}
      noMarginBottom={true}
    />
  );
};
